import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SOCIAL_LINKS } from "@/data/networks";

export const NetworkCard = ({ n }) => (
  <article
    data-testid={`network-card-${n.key}`}
    className="group relative flex h-full flex-col overflow-hidden rounded-[2rem] border border-[#E8DDD3] bg-white transition-shadow duration-500 hover:shadow-[0_30px_60px_-30px_rgba(31,26,23,0.35)]"
  >
    <div className="relative h-60 sm:h-72 lg:h-80 overflow-hidden">
      <img src={n.image} alt={n.imageAlt} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#181412]/70 via-[#181412]/10 to-transparent" />
      <span className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-medium text-[#1F1A17]">
        <n.Icon className="h-3.5 w-3.5" style={{ color: n.accent }} /> {n.name}
      </span>
      <div className="absolute bottom-5 left-5 right-5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#FBF8F4]">{n.audience}</div>
    </div>
    <div className="flex flex-1 flex-col p-6 sm:p-8">
      <h3 className="font-serif text-2xl sm:text-3xl tracking-tight text-[#1F1A17]">{n.headline.join(" ")}</h3>
      <p className="mt-3 text-sm leading-relaxed text-[#685F58]">{n.teaser}</p>
      <div className="mt-auto pt-7 flex flex-wrap items-center gap-3">
        <a
          href={SOCIAL_LINKS[n.key]}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`network-card-${n.key}-follow`}
          className="inline-flex items-center gap-1.5 rounded-full h-10 px-4 text-sm font-medium text-white transition-opacity duration-300 hover:opacity-90"
          style={{ background: n.accent }}
        >
          Follow <ArrowUpRight className="h-4 w-4" />
        </a>
        <Link
          to={`/${n.key}`}
          data-testid={`network-card-${n.key}-page`}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-[#1F1A17] hover:text-[#B4532A] transition-colors"
        >
          See the {n.name} page <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  </article>
);
